/**
 * @description
 * Add tabIndex to 0 if active and -1 if not
 * @specification
 * Adds role='option'.
 * Adds attribute 'aria-hidden=true' to 'icon' slot.
 */
export var dropdownSelectedItemBehavior = function dropdownSelectedItemBehavior(props) {
  return {
    attributes: {
      root: {
        role: 'option',
        tabIndex: props.active ? 0 : -1
      },
      icon: {
        'aria-hidden': 'true'
      }
    }
  };
};